import * as React from 'react';

import { auth } from '../../firebase';
import { loadDispensaryProducts, groupByStandardCategories } from '../products/product-utils';

import BodyWrapper from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';

import DisplayModal  from '../common/DisplayModal';
import ProductDetail from './ProductDetail';
import Spinner from '../common/Spinner';

import ProductTypes from '../home/ProductTypes';
import UpdateProductInfo from './UpdateProductInfo';
import Helmet from 'react-helmet';

import PropTypes from 'prop-types';

import styles from './AllProducts.module.css';

const UpdateProducts = ({dispensaryId}) => {

  const [modalProductId, setModalProductId] = React.useState();
  const [modalProductName, setModalProductName] = React.useState();

  const [dispensaryProducts, setDispensaryProducts] = React.useState([]);
  const [productsById, setProductsById] = React.useState();
  const [productsByType, setProductsByType] = React.useState();
  
  const [productType, setProductType] = React.useState(''); 
  const [filteredProducts, setFilteredProducts] = React.useState([]); 

  const switchType = React.useCallback((type) => {
    const products = productsByType[type] || [];
    setProductType(type);
    setFilteredProducts(products);     
  }, [productsByType]);

  const dispensaryCallback = React.useCallback((products) => {
    setDispensaryProducts(products.data);
    const prodsById = products.data.reduce((map, product) => map.set(product.id, product.metrc_product), new Map());
    setProductsById(prodsById);
    const prodsByType = groupByStandardCategories(products);
    setProductsByType(prodsByType);

    if (productType) {
      switchType(productType);
    } 
  }, [productType, switchType]); 

  React.useEffect(() => {
    const abortController = new AbortController();
    if (dispensaryId && !dispensaryProducts.length) {
      loadDispensaryProducts(dispensaryId, dispensaryCallback, abortController);
    }
    // Handle no category set, show all
    if (dispensaryProducts.length && !filteredProducts.length) { 
      setFilteredProducts(dispensaryProducts);
    }
    return () => abortController.abort();
  }, [dispensaryId, dispensaryCallback, dispensaryProducts, dispensaryProducts.length, filteredProducts.length]);  

  // enable product config
  const adminEmails = ['doug@ziprun.com', 'mike@ziprun.com'];
  const isAdminUser = (email) => {
    return adminEmails.indexOf(auth.currentUser.email) > -1 ||
           (email && email.indexOf('dispensary_owner') > -1);
  };

  return (
    <BodyWrapper>
    <Helmet>
      <title>Zip Run - All Metrc Products</title>
    </Helmet>  
    { filteredProducts.length 
      ? <>
          <div style={{paddingTop:'2rem'}}></div>
          <PrimaryHeader isCentered text={`Product Category: ${productType || 'All'} (${filteredProducts.length})`} />
          <ProductTypes isCondensed handleFilterClick={switchType} />
          
          { isAdminUser(auth.currentUser.email) && 
            <UpdateProductInfo dispensaryId={dispensaryId} onUpdate={() => {
              // trigger a fetch to refresh
              setDispensaryProducts([]);
            }} />
          }
      
          <table className={styles.prodTable}>
            <tbody>
              <tr className={styles.tableRow}>
                <th align="left">Id</th>
                <th align="left">Name</th>
                <th align="left">Metrc&nbsp;Category</th>
                <th align="left">DISPLAY:&nbsp;Name</th>
                <th align="left">Description</th>
                <th align="left">Category</th>
                <th align="left">Price</th>
              </tr>  
              { filteredProducts.map(product => {
                return (
                  <tr className={styles.tableRow} key={product.id}> 
                    <td>{ product.id }</td>
                    <td className={styles.prodName} 
                       onClick={() => { setModalProductId(product.id); setModalProductName(product.metrc_product.Name);}}>
                      { product.metrc_product.Name }  
                    </td>
                    <td>{ product.metrc_product.ProductCategoryName }</td>
                    { product.display_info.name && product.display_info.name !== product.metrc_product.Name 
                      ? <td className={styles.displayData}>{product.display_info.name}</td>
                      : <td className={styles.displayData}></td>
                    }
                    
                    { product.display_info.description
                      ? <td className={styles.displayData}>
                          <button onClick={() => {
                            alert(product.display_info.description);
                            return false;
                          }}>Desc</button>
                        </td>
                      : <td className={styles.displayData}></td>
                    }
            
                    { product.display_info.category && product.display_info.category.display_name
                      ? <td className={styles.displayData}>{product.display_info.category.display_name}</td>
                      : <td className={styles.displayData}></td>
                    }
                    { product.display_info.cost_usa_cents
                      ? <td className={styles.displayData}>${parseFloat(product.display_info.cost_usa_cents/100).toFixed(2)}</td>
                      : <td className={styles.displayData}></td>
                    } 
                  </tr>
                )
              })}
            </tbody>
          </table>
          
          { modalProductId > 0 && 
            <DisplayModal title={modalProductName} closeFn={() => { setModalProductId(0); setModalProductName();}}>
              <ProductDetail product={productsById.get(modalProductId)} />
            </DisplayModal>
          } 
      </>  
      : <div>
          <Spinner inSmallLayout />
        </div>
    }
    </BodyWrapper>
  )
}

UpdateProducts.propTypes = {
  dispensaryId: PropTypes.string
};

export default  UpdateProducts;